import styled from 'styled-components';

export const Checkmark = styled.span`
  background-color: #ffffff;
  border-radius: 50%;
  border: 1px solid rgba(151, 151, 151, 0.63);
  bottom: 0;
  box-sizing: border-box;
  height: 23px;
  left: 0;
  margin: auto;
  position: absolute;
  top: 0;
  transition: background 0.3s ease;
  width: 23px;

  &:after {
    content: '';
    display: block;
    opacity: 0;
    position: absolute;
    transition: opacity 0.3s ease;
  }
`;

export const Label = styled.label`
  cursor: pointer;
  display: block;
  padding-left: 35px;
  position: relative;
  user-select: none;

  input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;
  }

  &:hover input ~ ${Checkmark} {
    background: rgba(151, 151, 151, 0.1);
  }

  & input:checked ~ ${Checkmark}:after {
    opacity: 1;
  }

  & ${Checkmark}:after {
    background: #ffff;
    border-radius: 50%;
    border: 5px solid #0078D4;
    bottom: 0;
    height: 5px;
    left: 0;
    margin: auto;
    right: 0;
    top: 0;
    width: 5px;
  }
`;
